var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-avatar',_vm._b({attrs:{"background-color":_vm.bkgdColor}},'base-avatar',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }